// extracted by mini-css-extract-plugin
module.exports = {"root":"_1Gh0I","left":"_100QA","right":"cPVlg","small":"_1tFKQ","normal":"_27QHu"};